import { useEffect, useState } from 'react'
import { copyToClipboard } from 'utils'

export function useCopyToClipboard() {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false)
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [isCopied])

  const handleCopyAddress = (copyString: string | undefined) => {
    if (copyString) {
      setIsCopied(true)
      copyToClipboard(copyString)
    }
  }

  return {
    isCopied,
    handleCopyAddress,
  }
}
